import {createAction} from 'Shared/utilities/actionCreator'; // Assuming a utility function to create actions
import {AsyncPage, Empty} from 'Core/models/Async';
import {QuoteSearchDto} from 'Quoting/models/DTOs/QuoteSearch';
import {Page} from 'Core/models/Page';
import {QuoteSearchType} from 'Quoting/components/QuotingPage';

export type QuoteFilter = {
  opportunityNumber?: string;
  accountName?: string;
  customerName?: string;
};
export const clearSearchQuote = () => createAction(QuoteSearchActionType.CLEAR_SEARCH);

export const fetchQuotes = (searchtype: QuoteSearchType, searchvalue: string) =>
  createAction(QuoteSearchActionType.FETCH_QUOTES, {searchtype, searchvalue});
export const changeQuoteSearch = (quotes: AsyncPage<Page<QuoteSearchDto>>) =>
  createAction(QuoteSearchActionType.CHANGE_QUOTES, quotes);
export const changeQuoteSearchType = (searchtype: QuoteSearchType) =>
  createAction(QuoteSearchActionType.CHANGE_SEARCHTYPE, searchtype);
export const changeQuoteSearchValue = (searchvalue: string) =>
  createAction(QuoteSearchActionType.CHANGE_SEARCHVALUE, searchvalue);

export enum QuoteSearchActionType {
  CLEAR_SEARCH = 'quoteSearch/CLEAR_SEARCH_REULTS',
  FETCH_QUOTES = 'quoteSearch/FETCH_QUOTES',
  CHANGE_QUOTES = 'quoteSearch/CHANGE_QUOTES',
  CHANGE_SEARCHTYPE = 'quoteSearch/CHANGE_SEARCHTYPE',
  CHANGE_SEARCHVALUE = 'quoteSearch/CHANGE_SEARCHVALUE',
}

export const EmptyQuoteFilter: QuoteFilter = {
  opportunityNumber: null,
  accountName: null,
  customerName: null,
};

type QuoteSearchState = {
  quotes: AsyncPage<Page<QuoteSearchDto>>;
  searchtype: number;
  searchvalue: string;
};

const DEFAULT_QUOTE_SEARCH_STATE: QuoteSearchState = {
  quotes: new Empty(),
  searchtype: 1,
  searchvalue: '',
};

type QuoteSearchAction =
  | ReturnType<typeof clearSearchQuote>
  | ReturnType<typeof fetchQuotes>
  | ReturnType<typeof changeQuoteSearch>
  | ReturnType<typeof changeQuoteSearchValue>
  | ReturnType<typeof changeQuoteSearchType>;

export default (state: QuoteSearchState = DEFAULT_QUOTE_SEARCH_STATE, action: QuoteSearchAction): QuoteSearchState => {
  switch (action.type) {
    case QuoteSearchActionType.CHANGE_SEARCHTYPE:
      return {
        ...state,
        searchtype: action.payload,
      };
    case QuoteSearchActionType.CHANGE_SEARCHVALUE:
      return {
        ...state,
        searchvalue: action.payload,
      };
    case QuoteSearchActionType.CHANGE_QUOTES:
      return {
        ...state,
        quotes: action.payload,
      };
    case QuoteSearchActionType.CLEAR_SEARCH:
      return {
        ...state,
        searchtype: DEFAULT_QUOTE_SEARCH_STATE.searchtype,
        searchvalue: DEFAULT_QUOTE_SEARCH_STATE.searchvalue,
      };
    default:
      return state;
  }
};
